"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var appShellApis = _interopRequireWildcard(require("@icis/app-shell-apis"));
var _BaseStyles = _interopRequireDefault(require("./components/BaseStyles"));
var _ErrorBoundary = _interopRequireDefault(require("./components/ErrorBoundary"));
var _Nav = _interopRequireDefault(require("./components/Nav"));
var _PersistedApollo = _interopRequireDefault(require("./components/PersistedApollo"));
var _WalkMe = _interopRequireDefault(require("./components/WalkMe"));
var _getAppConfig = _interopRequireDefault(require("./constants/getAppConfig"));
var _context = require("./context");
var _getFonts = _interopRequireDefault(require("./utils/getFonts"));
var _logger = _interopRequireDefault(require("./utils/logger"));
/* istanbul ignore file */

const App = props => {
  let userData = null;
  let preferencesData = null;
  if (props.isPilet) {
    userData = props.useUser();
    preferencesData = props.useApplicationPreferences();
  }
  _react.default.useEffect(() => {
    (0, _getFonts.default)();
    const {
      trackPageView,
      trackAction
    } = props;
    // @ts-ignore
    appShellApis.init({
      trackPageView,
      trackAction
    });
  }, []);
  const {
    isPilet,
    authFailed,
    authReady
  } = props;
  const appConfig = (0, _getAppConfig.default)();
  const isAuthReady = isPilet || !authFailed && authReady;
  const isAuthFail = !isPilet && authFailed && !authReady;
  const providerData = {
    ...props,
    isPilet,
    ...(props.isPilet && {
      useUser: () => userData,
      useApplicationPreferences: () => preferencesData
    })
  };
  return /*#__PURE__*/_react.default.createElement(_context.HeaderApiContext.Provider, {
    value: providerData
  }, /*#__PURE__*/_react.default.createElement(_ErrorBoundary.default, {
    logger: _logger.default
  }, /*#__PURE__*/_react.default.createElement(_PersistedApollo.default, {
    graphQLUrl: appConfig.urls.graphQL,
    onAuthIssue: props.onAuthIssue,
    activityFeedBff: appConfig.urls.activityFeedBff
  }, /*#__PURE__*/_react.default.createElement(_BaseStyles.default, null, /*#__PURE__*/_react.default.createElement(_Nav.default, {
    authReady: isAuthReady,
    authFail: isAuthFail,
    authRetry: props.authRetry,
    onNavChange: props.onNavChange,
    onLogout: props.onLogout,
    logTimeToRender: props.logTimeToRender,
    ModalComp: props.ModalComp
  }), /*#__PURE__*/_react.default.createElement(_WalkMe.default, null)))));
};
var _default = exports.default = App;